import React, { useState } from "react";
import { Body, Top, Wrapper } from "./SketchWalletPayMobile.style";

export const SketchWalletPayMobile = () => {
  const [number, setNumber] = useState(0);

  const numbering = ["첫", "두", "세", "네", "다섯", "여섯", "일곱", "여덟"];
  const body = [
    <Body.Wrapper key={0}>
      <Body.Img src="/assets/video/img_1.gif" alt="animation1" />
      <Body.Title>앱 업데이트</Body.Title>
      <Body.Text>기존 사용하던 [구 스케치 월렛], [구 스케치 페이] 앱을 업데이트 합니다.</Body.Text>
    </Body.Wrapper>,
    <Body.Wrapper key={1}>
      <Body.Img src="/assets/img/swap_1.png" alt="swapImg1" />
      <Body.Title>앱 다운로드</Body.Title>
      <Body.Text>
        Play Store, App Store 로 이동해 '스케치 월렛' 을 검색한 뒤 신규 [스케치 월렛] 을 다운로드 받습니다.
      </Body.Text>
    </Body.Wrapper>,
    <Body.Wrapper key={2}>
      <Body.Img src="/assets/video/img_2.gif" alt="animation2" />
      <Body.Title>지갑생성 및 회원가입</Body.Title>
      <Body.Text>
        - 첫 실행 후 '지갑 생성' 과 '회원가입'을 진행합니다.
        <br />- 기존 회원과 동일한 이름, 연락처로 생성합니다.
        <br />- 생성된 지갑 주소를 복사합니다.
      </Body.Text>
    </Body.Wrapper>,
    <Body.Wrapper key={3}>
      <Body.Img src="/assets/img/swap_2.png" alt="swapImg2" />
      <Body.Title>스케치 스왑 시작하기</Body.Title>
      <Body.Text>사용하던 [구 스케치 월렛], [구 스케치 페이]에 접속합니다.</Body.Text>
    </Body.Wrapper>,
    <Body.Wrapper key={4}>
      <Body.Img src="/assets/video/img_3.gif" alt="animation3" />
      <Body.Title>스왑버튼 클릭</Body.Title>
      <Body.Text>
        앱 내 SKET를 확인할 수 있는 페이지로 이동해 활성화 되어있는 '뉴스케치 스왑' 버튼을 클릭합니다.
      </Body.Text>
    </Body.Wrapper>,
    <Body.Wrapper key={5}>
      <Body.Img src="/assets/img/swap_3.png" alt="swapImg3" />
      <Body.Title>지갑 주소 입력하기</Body.Title>
      <Body.Text>
        '스왑 받을 지갑 주소' 항목에 신규 [스케치 월렛]에서 생성한 지갑 주소를 입력한 뒤 동의 체크를 선택합니다.
      </Body.Text>
    </Body.Wrapper>,
    <Body.Wrapper key={6}>
      <Body.Img src="/assets/img/swap_4.png" alt="swapImg4" />
      <Body.Title>수량 정확히 입력</Body.Title>
      <Body.Text>'신청 수량'을 클릭해 스왑할 코인의 수량을 선택합니다.</Body.Text>
    </Body.Wrapper>,
    <Body.Wrapper key={7}>
      <Body.Img src="/assets/video/img_4.gif" alt="animation4" />
      <Body.Title>스왑 신청 완료</Body.Title>
      <Body.Text>내용을 다시 한번 확인한 뒤 '수수료 계산'과 '스왑 신청'을 완료합니다.</Body.Text>
    </Body.Wrapper>,
  ];
  const handleMovePage = (type) => {
    if (type === "up") {
      if (number === 7) return;
      setNumber(number + 1);
    } else {
      if (number === 0) return;
      setNumber(number - 1);
    }
  };
  return (
    <Wrapper>
      <Top.Wrapper>
        <Top.Wrapper>
          <Top.Text>
            <span>{numbering[number]} </span>
            번째
          </Top.Text>
        </Top.Wrapper>
        <Top.BtnContainer>
          <Top.Btn
            onClick={() => handleMovePage("down")}
            src={number === 0 ? "/assets/img/swap_btn_no.svg" : "/assets/img/swap_btn_yes.svg"}
          />
          <Top.Btn
            onClick={() => handleMovePage("up")}
            style={{ rotate: "180deg" }}
            src={number === 7 ? "/assets/img/swap_btn_no.svg" : "/assets/img/swap_btn_yes.svg"}
          />
        </Top.BtnContainer>
      </Top.Wrapper>

      {/* body     */}
      {body[number]}
    </Wrapper>
  );
};
